import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ExpenseSections } from '../../../constants/expense';
import ExpenseDetailCard from './expenseDetailCard';
import { useGetExpenseById } from '../../../hooks/useGetExpenseById';
import { useParams } from 'react-router-dom';
import { IExpense } from '../../../interface/expense';
import { usePage } from '../../../context/PageContext';
import AddEditTransactionHeader from '../../dashboard/addTransaction/addEditTransactionHeader';
import Notes from '../../conflictSearch/notes';
import { NotesEntity } from '../../../constants/notes';
import { useNavigationStack } from '../../../context/NavigationStackContext';
import CustomTabs from '../../customTabs/customTabs';
import DetailScrollArea from '../../detailScrollArea/detailScrollArea';

const ExpenseDetailTabs = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { goBack } = useNavigationStack();
  const { setTitle } = usePage();
  const [selectedTab, setSelectedTab] = useState<string>();
  const { data: expense, isLoading } = useGetExpenseById({
    id,
    relations: ['expenseUser:fullName', 'unit', 'expenseType'],
    fields: [
      'subject',
      'expenseDate',
      'salesPriceNet',
      'status',
      'unitPriceNet',
      'units',
      'hasImportantNotes',
      'hasNotes',
      'costForward',
      'taxFree',
    ],
  });
  const handleBack = () => {
    goBack();
  };
  useEffect(() => {
    if (expense && !isLoading) {
      setTitle(
        <AddEditTransactionHeader
          title={expense?.subject}
          subTitle={t('expense:expense')}
          handleBack={handleBack}
        />,
      );
    }
  }, [expense, isLoading]);

  const items = useMemo(
    () => [
      {
        key: ExpenseSections.general,
        label: t('common:tab.general'),
        children: (
          <DetailScrollArea>
            <ExpenseDetailCard expense={expense as IExpense} isLoading={isLoading} />
          </DetailScrollArea>
        ),
      },
      {
        key: ExpenseSections.notes,
        label: t('common:tab.notes'),
        children: <Notes entitySubject={expense?.subject ?? ''} entity={NotesEntity.EXPENSE} />,
      },
    ],
    [expense, t],
  );
  return (
    <CustomTabs variant="pill" activeKey={selectedTab} onChange={setSelectedTab} items={items} />
  );
};

export default ExpenseDetailTabs;
